import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Row, Input, Button, Card } from 'antd';

import { API_UPDATE_PLAN, API_NEXT_STEP } from '../../config';
import { switch_api } from '../../actions/switch_api';
import { getJobUuid } from '../../actions/jobs';

import teethSprites from '../../assets/svgicons/teeth-sprites.svg';
import cross from '../../assets/svgicons/cross.svg';

import '../../components/PanelBox/index.less'

class PanelBox extends React.Component {
  render () {
    return (
      <Card className={`panel-box${this.props.className}`} title={this.props.title} bordered={false} bodyStyle={this.props.bodyStyle} style={{textAlign: 'center', maxWidth: '580px', margin: 'auto'}}>
        {this.props.children}
      </Card>
    )
  }
}

const upperTeeth =   [ 18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28 ];
const upperSprites = [  7,  6,  5,  4,  3,  2,  1,  0,  8,  9, 10, 11, 12, 13, 14, 15 ];
const lowerTeeth =   [ 48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38 ];
const lowerSprites = [ 31, 30, 29, 28, 27, 26, 25, 24, 16, 17, 18, 19, 20, 21, 22, 23 ];
const teeth = {};
upperTeeth.concat(lowerTeeth).forEach((elm) => {
  teeth[elm] = true;
});

class PlanUpdateForm extends Component {
  constructor(props) {
    super(props);

    this.isModelsValid = true;

    this.updatePlan = this.updatePlan.bind(this);

    this.state = {};
    this.state.loading = false;
    this.state.teeth = {};
    this.state.job = {};
    this.state.upperLayers = [];
    this.state.lowerLayers = [];
    this.state.upperModels = [];
    this.state.lowerModels = [];

    getJobUuid(this.props.match.params.uuid)
      .then((job) => {
        this.state.teeth = Object.assign({}, teeth);
        this.state.job = job;
        this.state.upperLayers = this.state.job.t_plan.json_data.plan.upper ? [ ...Object.keys(this.state.job.t_plan.json_data.plan.upper) ] : [];
        this.state.lowerLayers = this.state.job.t_plan.json_data.plan.lower ? [ ...Object.keys(this.state.job.t_plan.json_data.plan.lower) ] : [];
        this.state.upperModels = new Array(this.state.upperLayers.length * 2).fill(null);
        this.state.lowerModels = new Array(this.state.lowerLayers.length * 2).fill(null);
        this.forceUpdate();
      })
      .catch();
  }

  checkModels() {
    this.isModelsValid = true;
    for (let i = 0; i < this.state.upperModels.length; i ++) {
      if (
        i &&
        (
          ((i % 2 !== 0) && parseInt(this.state.upperModels[i]) <  parseInt(this.state.upperModels[i - 1])) ||
          ((i % 2 === 0) && parseInt(this.state.upperModels[i]) <= parseInt(this.state.upperModels[i - 1]))
        )
      ) {
        this.isModelsValid = false;
        break;
      }
    }
    for (let i = 0; i < this.state.lowerModels.length; i ++) {
      if (
        i &&
        (
          ((i % 2 !== 0) && parseInt(this.state.lowerModels[i]) <  parseInt(this.state.lowerModels[i - 1])) ||
          ((i % 2 === 0) && parseInt(this.state.lowerModels[i]) <= parseInt(this.state.lowerModels[i - 1]))
        )
      ) {
        this.isModelsValid = false;
        break;
      }
    }
  }

  checkbox(e, elm) {
    this.state.teeth[elm] = !e.target.checked;
    this.forceUpdate();
  }

  getInputs(elm, i, position) {
    return (
      <div key={elm} className={'sf-plan_update-specify_models'}>
        <div className={'sf-plan_update-specify_models-h2'}>Layer №{elm} models</div>
        <Row type='flex' justify='left'>
          <div className={'sf-plan_update-specify_models-input_container'}>
            <Input
              value={this.state[position][i * 2]}
              disabled={this.state.loading}
              onChange={(e) => {
                const pos = this.state[position];
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                pos[i * 2] = e.target.value;
                pos[i * 2 - 1] !== 'undefined' ? pos[i * 2 - 1] = parseInt(pos[i * 2]) - 1: null;
                isNaN(pos[i * 2 - 1]) ? pos[i * 2 - 1] = '' : null;
                this.checkModels();
                this.forceUpdate();
              }}
            />
          </div>
          <div className={'sf-plan_update-specify_models-input_container -right'}>
            <Input
              value={this.state[position][i * 2 + 1]}
              disabled={this.state.loading}
              onChange={(e) => {
                const pos = this.state[position];
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                pos[i * 2 + 1] = e.target.value;
                pos[i * 2 + 2] !== 'undefined' ? pos[i * 2 + 2] = parseInt(pos[i * 2 + 1]) + 1 : null;
                isNaN(pos[i * 2 + 2]) ? pos[i * 2 + 2] = '' : null;
                this.checkModels();
                this.forceUpdate();
              }}
            />
          </div>
        </Row>
      </div>
    );
  }

  nextStep() {
    let token =  localStorage.getItem('token');

    return fetch(switch_api(API_NEXT_STEP(this.props.match.params.uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_NEXT_STEP }: ${response.statusText}`);
        this.setState({loading:false});
      }
      
      window.location = '/home';
    })
    .catch((e) => {
      console.warn(e);
      this.setState({loading:false});
    })
  }

  updatePlan() {
    let token =  localStorage.getItem('token');

    const models = [];
    const newTeeth = {};
    for (let i = 0; i < this.state.upperModels.length - 1; i += 2) {
      models.push({
        index_from: parseInt(this.state.upperModels[i]),
        index_to: parseInt(this.state.upperModels[i + 1]),
        layer_number: i * 0.5 + 1,
        jaw_type: 'upper'
      });
    }
    for (let i = 0; i < this.state.lowerModels.length - 1; i += 2) {
      models.push({
        index_from: parseInt(this.state.lowerModels[i]),
        index_to: parseInt(this.state.lowerModels[i + 1]),
        layer_number: i * 0.5 + 1,
        jaw_type: 'lower'
      });
    }

    for (let key in this.state.teeth) {
      if (!this.state.teeth[key]) {
        newTeeth[key] = false;
      }
    }

    this.setState({loading:true});

    return fetch(switch_api(API_UPDATE_PLAN(this.props.match.params.uuid)), {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({
        setup: newTeeth,
        models
      })
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_UPDATE_PLAN }: ${response.statusText}`);
      }

      this.nextStep();
      // return response;
    })
    .catch((e) => {
      console.warn(e);
      this.setState({loading:false});
    })
  }

  render() {
    return (JSON.parse(localStorage.getItem('techJobs')).map((elm) => elm.uuid).indexOf(this.props.match.params.uuid) < 0) ? (window.location = '/home') : (
      <PanelBox title={'Plan Update'}>
        <Row type='flex' justify='center'>
          {upperTeeth.map((elm, i) => {
            return (
              <div key={elm} className={'sf-plan_update-remove_teeth-item'}>
                <div className={'sf-plan_update-remove_teeth-item-icon'} style={{backgroundImage: `url(${teethSprites})`, backgroundPositionY:`${-32 * upperSprites[i]}px`}}/>
                <div className={`sf-plan_update-remove_teeth-item-cross ${this.state.teeth[elm] ? '' : '-visible'}`} style={{backgroundImage: `url(${cross})`}}/>
                <div>{elm}</div>
                <Checkbox onChange={(e) => this.checkbox(e, elm)}/>
              </div>
            );
          })}
        </Row>
        <Row type='flex' justify='center'>
          {lowerTeeth.map((elm, i) => {
            return (
              <div key={elm} className={'sf-plan_update-remove_teeth-item'}>
                <Checkbox onChange={(e) => this.checkbox(e, elm)}/>
                <div>{elm}</div>
                <div className={'sf-plan_update-remove_teeth-item-icon'} style={{backgroundImage: `url(${teethSprites})`, backgroundPositionY:`${-32 * lowerSprites[i]}px`}}/>
                <div className={`sf-plan_update-remove_teeth-item-cross -lower ${this.state.teeth[elm] ? '' : '-visible'}`} style={{backgroundImage: `url(${cross})`}}/>
              </div>
            );
          })}
        </Row>
        <Row type='flex' justify='left' style={{padding: '0 20px 0 20px'}}>
          <div className={'sf-plan_update-specify_models-h1'}>Upper arch</div>
          {this.state.upperLayers.map((elm, i) => this.getInputs(elm, i, 'upperModels'))}
          <div className={'sf-plan_update-specify_models-h1'}>Lower arch</div>
          {this.state.lowerLayers.map((elm, i) => this.getInputs(elm, i, 'lowerModels'))}
        </Row>
        <Row type="flex" justify="center">
          <Button
            style={{margin: '24px 0 0 0'}}
            loading={this.state.loading}
            className="upload-demo-start"
            type="primary"
            disabled={
              !this.isModelsValid ||
              this.state.loading ||
              this.state.upperModels.filter((elm) => !Boolean(elm)).length ||
              this.state.lowerModels.filter((elm) => !Boolean(elm)).length
            }
            onClick={this.updatePlan}>
            Update
          </Button>
        </Row>
      </PanelBox>
    );
  }
};

// export default connect(({ jobs }) => ({ jobs }))(PlanUpdateForm);
export default PlanUpdateForm;



// WEBPACK FOOTER //
// ./src/views/Cases/planUpdateForm.jsx